import script from "./AnnouncementView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementView.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementView.vue?vue&type=style&index=0&id=5bb566c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb566c3"]])

export default __exports__